import script from "./ActivityLog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivityLog.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__